import { ref, watch } from 'vue'
import Swal from 'sweetalert2'
import { usePriceKey } from '@/composables/usePriceKey'
import { useSiteConfigStore } from '@/stores/config/site'

export function useTierMessageNotifier() {
  const hasShownTierMessage = ref(false)

  const { shouldApplyDynamicPrice } = usePriceKey()
  const siteConfigStore = useSiteConfigStore()

  const showSuccessMessage = () => {
    const message =
      siteConfigStore.getPriceRuleMessageSuccess ||
      '¡Felicidades! Accedes a precios de fábrica. ¡Disfruta tus ahorros!'

    Swal.fire({
      icon: 'success',
      title: '¡Precios mejorados!',
      html: message,
      timer: 6000,
      showConfirmButton: false,
      timerProgressBar: true,
      toast: true,
      position: 'top-end'
    })
  }

  watch(shouldApplyDynamicPrice, (applies) => {
    if (applies && !hasShownTierMessage.value) {
      hasShownTierMessage.value = true
      showSuccessMessage()
    } else if (!applies) {
      hasShownTierMessage.value = false
    }
  })
}
